<script lang="ts">
	import { Container, Input, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let editableObject;
</script>

<Container padding="scrollPaddings">
	<Text class="mb-m">
		{$format('change_profile_name', { default: 'Change profile name' })}
	</Text>
	<!-- DO NOT REMOVE COMMENT -->
	<Input
		icon="fas fa-user"
		class="pb-s"
		bind:value={editableObject.profileName}
		autofocus={true}
		size="l"
		label="Name"
		id="input-d0czo5s"
		aria-labelledby="input-d0czo5s"
	/>
</Container>
